export default {"src":"/_next/static/media/favicon.94b306ae.ico","height":48,"width":48,"blurWidth":0,"blurHeight":0};